export default "__VITE_ASSET__c5571a8c__"